import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { EInvoiceDto } from '../../../../data/models'
import { useConfigContext } from '../../../ui-config'
import { EInvoiceCockpitKpis } from './model'

export function useEInvoiceCockpit(): FetchResult<EInvoiceDto[]> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceDto[]>,
    FetchError
  >('/einvoicescockpit', fetchJson<EInvoiceDto[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useEInvoiceCockpitKpis(): FetchResult<EInvoiceCockpitKpis> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceCockpitKpis>,
    FetchError
  >('/kpis', fetchJson<EInvoiceCockpitKpis>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
